export default theme => ({
    headerContainer:{
        display : 'flex',    
        marginBottom : '5px',
        alignItems: 'center'
    },
    formContainer: {
        padding: '10px 8px 25px 8px'
    }
})